import { ref, watch } from 'vue'
import { logTime, msToReadableString } from '@/core/utils'

export function useInactiveTimeout(name: string, ms: number, debug = false) {
  const timeout = ref()
  const inactived = ref(false)

  function reset() {
    debug && console.debug('InactiveTimeout.reset', { name, ms }, logTime())
    inactived.value = false
    clearTimeout(timeout.value)
    timeout.value = setTimeout(() => {
      inactived.value = true
    }, ms)
  }

  function stop() {
    clearTimeout(timeout.value)
    debug && console.debug('InactiveTimeout.stop', { name }, logTime())
  }

  function onTimeout(handler: () => void) {
    watch(inactived, (newValue, oldValue) => {
      if (newValue) {
        debug && console.debug('InactiveTimeout.onTimeout', { name }, logTime())
        clearTimeout(timeout.value)
        handler()
      }
    })
  }

  return {
    reset,
    stop,
    onTimeout,
  }
}
